import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackAddToWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackAddToWishList";
import { PartialSpecific } from "@store/Framework/Types/Common";

const useTrackAddToWishList = (
    parameters: PartialSpecific<TrackAddToWishListParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.addToWishList, parameters, options);
};

export default useTrackAddToWishList;
